import { CategoryResult, EvaluationRangeOpenApi } from 'isophi-pdfs-api';

export const getRanges = (rangesInfo: EvaluationRangeOpenApi, categoryResult: CategoryResult) => {
  const categoryRule = rangesInfo.categoryRules.filter((val) => val.categoryUuid === categoryResult.category.uuid)[0];
  return categoryRule.ranges.slice(1).map((val) => val.minPoint);
};
